import {
  ArrayLayoutProps,
  ArrayTranslations,
  RankedTester,
  isObjectArrayControl,
  isPrimitiveArrayControl,
  or,
  rankWith,
} from "@jsonforms/core";
import { Unwrapped } from "@jsonforms/material-renderers";
import {
  withArrayTranslationProps,
  withJsonFormsArrayLayoutProps,
  withTranslateProps,
} from "@jsonforms/react";
import { Box } from "@mui/system";

const { MaterialArrayControlRenderer } = Unwrapped;

export const StylableMaterialArrayControlRenderer = (
  props: ArrayLayoutProps & { translations: ArrayTranslations },
) => {
  return (
    <Box id={props.id}>
      <MaterialArrayControlRenderer {...props} />
    </Box>
  );
};

export const stylableMaterialArrayControlTester: RankedTester = rankWith(
  5,
  or(isObjectArrayControl, isPrimitiveArrayControl),
);

export default withJsonFormsArrayLayoutProps(
  withTranslateProps(
    withArrayTranslationProps(StylableMaterialArrayControlRenderer),
  ),
);
